"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "corte-franca": {
    "c63a6395": [{
      "hkey": "674d6043",
      "slug": "colombaro-timoline",
      "name": "Colombaro-Timoline",
      "primary": true,
      "skipSearch": false
    }],
    "colombaro": [{
      "hkey": "674d6043",
      "slug": "colombaro-timoline",
      "name": "Colombaro-Timoline",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "eaa74dae": [{
      "hkey": "dab941cc",
      "slug": "nigoline-bonomelli",
      "name": "Nigoline-Bonomelli",
      "primary": true,
      "skipSearch": false
    }],
    "nigoline": [{
      "hkey": "dab941cc",
      "slug": "nigoline-bonomelli",
      "name": "Nigoline-Bonomelli",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "0e8e80c4": [{
      "hkey": "674d6043",
      "slug": "colombaro-timoline",
      "name": "Colombaro-Timoline",
      "primary": true,
      "skipSearch": false
    }],
    "timoline": [{
      "hkey": "674d6043",
      "slug": "colombaro-timoline",
      "name": "Colombaro-Timoline",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "corte-franca"
    }]
  }
};
exports["default"] = _default;